import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import AuthSplitLayout from '../components/auth/AuthSplitLayout';
import { useAuth } from '../context/AuthContext';
import { formatAuthError } from '../utils/authErrors';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(formatAuthError(err));
    } finally {
      setSubmitting(false);
    }
  }

  const footerRow = (
    <div className="auth-split-footer-row">
      <button type="button" className="auth-split-inline-link" disabled title="Coming soon">
        Forgot password
      </button>
      <p className="auth-split-register-line">
        Not yet register? <Link to="/register">Create account</Link>
      </p>
    </div>
  );

  return (
    <AuthSplitLayout
      title="Sign in"
      subtitle="Hi there, welcome back to Polyrion!"
      footerRow={footerRow}
    >
      <form className="auth-split-form" onSubmit={handleSubmit} noValidate>
        <label className="auth-split-field">
          <span className="auth-split-label">
            Email <abbr title="required">*</abbr>
          </span>
          <input
            type="email"
            name="email"
            autoComplete="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label className="auth-split-field">
          <span className="auth-split-label">
            Password <abbr title="required">*</abbr>
          </span>
          <span className="auth-split-input-wrap">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              autoComplete="current-password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="auth-split-input-toggle"
              onClick={() => setShowPassword((v) => !v)}
              tabIndex={-1}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? <FiEyeOff aria-hidden /> : <FiEye aria-hidden />}
            </button>
          </span>
        </label>

        {error ? <p className="auth-split-error" role="alert">{error}</p> : null}

        <button type="submit" className="auth-split-submit" disabled={submitting}>
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </AuthSplitLayout>
  );
}
